import React from 'react';
import logo from './logo.webp';
import { Link } from "react-router-dom";

//  Using a higher-order component:
// function Nav(props) {

// ES5 Arrow Function
function Nav() {
 const styles = {
  ul: {
   display: "flex",
  },

  li: {
   margin: "0 10px",
   listStyleType: "none",
   color: "black",
   fontFamily: "Karla",
   fontSize: 20,
   textDecoration: "none",
  },
 };

 return (
  <>
  {/* <img src={logo} alt="Logo" />
  <nav>
   Nav */}
   {/* 
   <ul>
   jsx-a11y/anchor-is-valid
   <li><a href=""></a></li>
   <li><a href=""></a></li>
   <li><a href=""></a></li>
   <li><a href=""></a></li>
  </ul> */}
 {/* </nav> */}
 <img src={logo} alt="Logo" />
 <nav>
    <ul style={styles.ul}>
     <li style={styles.li}>
      <Link to="/">HOME</Link>
     </li>
     <li style={styles.li}>
      <Link to="/">ABOUT</Link>
     </li>
     <li style={styles.li}>
      <Link to="/">MENU</Link>
     </li>
     <li style={styles.li}>
      <Link to="/reservations">RESERVATIONS</Link>
     </li>
     <li style={styles.li}>
      <Link to="/">ORDER ONLINE</Link>
     </li>
     <li style={styles.li}>
      <Link to="/">LOGIN</Link>
     </li>
    </ul>
   </nav>
  </>
 );
}

export default Nav;
